import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Input, Nav, NavItem, Row } from 'reactstrap';
import { Mic, Send } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
const FinanceQuest = () => {
    const [message, setMessage] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const scrollRef = useRef(null);
    const suggestedQuestions = [
        "How much property can I afford based on my income, savings, and debts?",
        "What would my monthly mortgage payments likely be for different property prices and interest rates?",
        "Can AI generate design ideas based on a single inspiration image I have?",
        "How can I best arrange furniture in a room to optimize space and flow?",
        "What is the optimal layout for a specific room type (e.g., living room, bedroom, kitchen) in my new home?",
        "How can I visualize different room configurations before moving furniture? ",
        "What color palettes would work well in a specific room based on its natural light and intended mood?",
        "How can I find complementary colors for my existing furniture or decor?",
        "Can I see how different paint colors would look on my walls before painting?",
        "What type of furniture and decor would fit my chosen style and room dimensions?",
        "Where can I find furniture and decor items that match the AI's suggestions?",
        "How can I see how a specific piece of furniture or decor would look in my room before buying it?",
        "Can I see a realistic 3D rendering of my room with the suggested design? ",
        "Can I schedule a visit?",
        "Is financing available?",
        "What are the nearby amenities?",
        "3 BHK flats for rent in Gotri Vadodara?",
        "Rent of 3 BHK apartment in Gotri?",
        "3 BHK apartment rent price Gotri?",
        "How much does a 3 BHK apartment cost to rent in Gotri?",
        "3 BHK flats for rent near Gotri Vadodara?",
        "3 BHK apartment for rent in Gotri with amenities?",
        "3 BHK apartment for rent in Gotri with parking?",
        "3 BHK apartment for rent in Gotri furnished?",
        "What is the price of the property?",
        "Can I schedule a visit?",
        "Is financing available?",
        "What are the nearby amenities?",
        "3 BHK flats for rent in Gotri Vadodara?",
        "Rent of 3 BHK apartment in Gotri?",
        "3 BHK apartment rent price Gotri?",
        "How much does a 3 BHK apartment cost to rent in Gotri?",
        "3 BHK flats for rent near Gotri Vadodara?",
        "3 BHK apartment for rent in Gotri with amenities?",
        "3 BHK apartment for rent in Gotri with parking?",
        "3 BHK apartment for rent in Gotri furnished?",
    ];

    const handleSendMessage = (msg) => {
        const text = msg || message;
        if (text.trim()) {
            const whatsappURL = `https://wa.me/919586363303?text=${encodeURIComponent(text)}`;
            window.open(whatsappURL, '_blank');
        }
    };
    useEffect(() => {
        const interval = setInterval(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollTop += 1;
                if (scrollRef.current.scrollTop >= scrollRef.current.scrollHeight - scrollRef.current.clientHeight) {
                    scrollRef.current.scrollTop = 0;
                }
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);
    const handleSendTextareaMessage = () => {
        if (!message.trim()) {
            console.log("Empty message, not sending.");
            return;
        }

        const whatsappURL = `https://wa.me/919586363303?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');

        setMessage(""); // Clear textarea after sending
    };

    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);

    // Voice recognition setup
    useEffect(() => {
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            const recognition = new SpeechRecognition();
            recognition.continuous = false;
            recognition.lang = 'en-IN';
            recognition.interimResults = false;

            recognition.onstart = () => setListening(true);
            recognition.onend = () => setListening(false);
            recognition.onerror = (event) => console.error("Speech recognition error:", event);

            recognition.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setMessage(prev => prev + " " + transcript);
            };

            recognitionRef.current = recognition;
        } else {
            alert("Sorry, your browser doesn't support speech recognition.");
        }
    }, []);

    const handleMicClick = () => {
        if (recognitionRef.current) {
            if (listening) {
                recognitionRef.current.stop();
            } else {
                recognitionRef.current.start();
            }
        }
    };


    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    return (
        <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
            <Container fluid={true} className="py-0">
                <div className="text-center my-3">
                    <Link to="/interior-design" >
                        <button
                            style={{
                                background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                color: "#fff",
                                border: "none",
                                borderRadius: "25px",
                                padding: "10px 20px",
                                marginRight: "10px",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "background 0.3s ease"
                            }}
                        >
                            AI in Interior Design
                        </button>
                    </Link>
                    <Link to="/ai-products">
                        <button
                            style={{
                                background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                color: "#fff",
                                border: "none",
                                borderRadius: "25px",
                                padding: "10px 20px",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "background 0.3s ease"
                            }}
                        >
                            AI in Interior Design
                        </button>
                    </Link>
                </div>

                <Row className="justify-content-center">
                    <Col xl={8} lg={8} md={10}>
                        <Card style={{ background: "rgba(255, 255, 255, 0.1)", border: "none", borderRadius: "15px", padding: "20px" }}>
                            <CardBody className="d-flex flex-column align-items-center">
                                <CardTitle className="mb-4 text-center" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                                    AI In Finance Planning
                                </CardTitle>
                                <div style={{ position: "relative", width: "100%" }}>
                                    <Input
                                        type="textarea"
                                        className="form-control"
                                        id="question"
                                        name="question"
                                        placeholder="Type your question here..."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        style={{
                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                            color: "#fff",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            minHeight: "120px",
                                            resize: "none",
                                            transition: "all 0.3s ease",
                                            '::placeholder': { color: '#fff' }
                                        }}
                                        onFocus={(e) => e.target.style.backgroundColor = "rgba(255, 255, 255, 0.4)"}
                                        onBlur={(e) => e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)"}
                                    />
                                    {/* Mic Button */}
                                    <button
                                        type="button"
                                        onClick={handleMicClick}
                                        style={{
                                            position: "absolute",
                                            bottom: "75px",
                                            right: "10px",
                                            background: listening ? "red" : "linear-gradient(to right, #6a11cb, #2575fc)",
                                            border: "none",
                                            padding: "8px 10px",
                                            borderRadius: "50%",
                                            color: "#fff",
                                            cursor: "pointer",
                                            boxShadow: "0 0 10px rgba(0,0,0,0.5)"
                                        }}
                                        title={listening ? "Listening..." : "Start voice input"}
                                    >
                                        <Mic size={18} />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSendTextareaMessage}
                                        style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            right: "10px",
                                            background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                            border: "none",
                                            padding: "8px 12px",
                                            borderRadius: "20px",
                                            color: "#fff",
                                            cursor: "pointer"
                                        }}
                                    >
                                        <Send size={18} />
                                    </button>
                                </div>
                                <div className="mt-4" style={{ overflow: "hidden", width: "100%" }}>
                                    <div ref={scrollRef} style={{ overflowY: "auto", maxHeight: "430px", scrollbarWidth: "thin" }}>
                                        <Nav className="d-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "repeat(4, auto)", gap: "10px" }}>
                                            {suggestedQuestions.map((q, index) => (
                                                <NavItem key={index}>
                                                    <NavLink
                                                        onClick={() => handleSendMessage(q)}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#fff",
                                                            background: "rgba(255, 255, 255, 0.2)",
                                                            padding: "10px 15px",
                                                            borderRadius: "5px",
                                                            textDecoration: "none",
                                                            display: "block",
                                                            textAlign: "center",
                                                            transition: "background 0.3s ease"
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.background = "rgba(255, 255, 255, 0.4)"}
                                                        onMouseLeave={(e) => e.target.style.background = "rgba(255, 255, 255, 0.2)"}
                                                    >
                                                        {q}
                                                    </NavLink>
                                                </NavItem>
                                            ))}
                                        </Nav>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <div
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    {/* Icons Container */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "12px",
                            gap: "10px", // Reduced gap for a more compact design
                        }}
                    >
                        {/* WhatsApp Icon */}
                        <a
                            href={generateWhatsAppLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                fontSize: "1.2rem", // Reduced font size
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "40px", // Reduced icon size
                                height: "40px",
                                background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                                borderRadius: "50%",
                                boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                                transition: "all 0.3s ease",
                            }}
                            title="Chat on WhatsApp"
                            onMouseEnter={(e) => {
                                e.target.style.transform = "scale(1.1)";
                                e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "scale(1)";
                                e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                            }}
                        >
                            <FaWhatsapp />
                        </a>

                        {/* Call Icon */}
                        <a
                            href="tel:+919586363303"
                            style={{
                                color: "white",
                                fontSize: "1.2rem", // Reduced font size
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "40px", // Reduced icon size
                                height: "40px",
                                background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                                borderRadius: "50%",
                                boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                                transition: "all 0.3s ease",
                            }}
                            title="Call Us"
                            onMouseEnter={(e) => {
                                e.target.style.transform = "scale(1.1)";
                                e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "scale(1)";
                                e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                            }}
                        >
                            <i className="fas fa-phone" />
                        </a>
                    </div>

                    {/* Query Button */}
                    <Link
                        to="/dashboard"
                        title="Any Questions or Queries?"
                        style={{
                            background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                            border: "none",
                            borderRadius: "9999px",
                            padding: "10px 20px", // Adjusted padding
                            fontSize: "14px", // Reduced font size
                            color: "white",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                            transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = "scale(1.1)";
                            e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = "scale(1)";
                            e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
                        }}
                    >
                        Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                    </Link>
                </div>
            </Container>
        </div>
    );
}

export default FinanceQuest
